import React from 'react';
import { FindContentView, FindContentViewProps } from './FindContent.view';
import { useForm } from 'react-hook-form';
import {
  CoreImportFolderFieldsFragment,
  ImportSourceFieldsFragment,
  SocialProfileFieldsFragment
} from '../../../models/graphql';

export type FindContentControllerProps = {
  sources: ImportSourceFieldsFragment[];
  folders: CoreImportFolderFieldsFragment[];
  socialProfiles: SocialProfileFieldsFragment[];
  reFetch: CallableFunction;
};

export const FindContentController = (props: FindContentControllerProps): JSX.Element => {
  const useFormInstance = useForm({
    mode: 'onSubmit',
    criteriaMode: 'all',
    shouldFocusError: true,
    reValidateMode: 'onSubmit'
  });

  const fetchMorePosts = (callBack: CallableFunction) => {
    callBack();
  };

  const viewProps: FindContentViewProps = {
    ...props,
    useFormInstance,
    profiles: props.socialProfiles,
    fetchMorePosts
  };
  return <FindContentView {...viewProps} />;
};
